import { Link } from 'react-router-dom';
import { useI18n } from '@/shared/i18n/useT';

/**
 * Legal links for the first screen of each brand. Disposición 954/2025 requires
 * the cancellation link to be visible "a simple vista, en lugar destacado y en
 * el primer acceso", which is why this sits on the sign-in and booking screens
 * rather than only inside the legal pages.
 */
export function LegalFooter() {
  const { t } = useI18n();
  return (
    <footer className="mx-auto mt-10 flex max-w-3xl flex-wrap items-center justify-center gap-x-4 gap-y-2 border-t border-border px-3 pt-5 text-sm text-muted">
      <Link to="/terms" className="tap-target text-accent hover:text-accent-hover">
        {t('legal.terms.shortTitle')}
      </Link>
      <Link to="/privacy" className="tap-target text-accent hover:text-accent-hover">
        {t('legal.privacy.shortTitle')}
      </Link>
      <Link to="/baja" className="tap-target font-medium text-accent hover:text-accent-hover">
        {t('legal.cancellation.linkLabel')}
      </Link>
    </footer>
  );
}
